import React from 'react';
import Image from 'next/legacy/image';

import whiteLogo from '@/images/gl-logo-full-white.svg';
import blockLoader from '@/images/block-loader-hd.gif';

export function FullPageLoader({ children }: { children?: React.ReactNode }) {
  return (
    <div className="flex h-screen w-screen items-center justify-center bg-gradient-to-b from-[#00d9b4] to-[#99e4d7]">
      <div className="relative flex flex-col items-center">
        <div className="max-h-[45px] max-w-[250px] desktop:max-h-[50px] desktop:max-w-[325px]">
          <Image src={whiteLogo} alt="Greenlight logo" />
        </div>

        {children}

        <div className="h-[38px] w-[58px] mt-[112px] desktop:h-[68px] desktop:w-[88px]">
          <img src={blockLoader.src} alt="Block loader gif" />
        </div>
      </div>
    </div>
  );
}
